import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { BugIcon } from '../assets/icon/bug-icon.tsx';

export function Footer() {
    const { t } = useTranslation();
    const year = new Date().getFullYear();
    const location = useLocation();

    return (
        <footer className="w-full px-6 pb-4">
            <div className="mx-auto flex w-full max-w-5xl flex-col rounded-xl border border-white/15 bg-white/10 px-5 py-2 text-xs text-white/70 backdrop-blur md:flex-row md:items-center md:justify-between">
                <span className="flex items-center gap-2">
                    © {year} <a href="https://unvox.ai/" className="underline-offset-4 hover:underline">UNVOX</a>
                    <small className="text-[10px] uppercase tracking-[0.25em]">{t('global.footer.txtAllRightsReserved')}</small>
                </span>
                <ul className="flex items-center gap-4">
                    <li>
                        <a
                            href="/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline-offset-4 hover:underline"
                        >
                            {t('global.footer.linkPrivacyPolicy')}
                        </a>
                    </li>
                    <li>
                        <Link to="/terms" className="underline-offset-4 hover:underline">
                            {t('global.footer.linkTerms')}
                        </Link>
                    </li>
                    <li>
                        <Link to="/refunds" className="underline-offset-4 hover:underline">
                            {t('global.footer.linkRefunds')}
                        </Link>
                    </li>
                    <li>
                        <Link to="/support" className="underline-offset-4 hover:underline">
                            {t('global.footer.linkSupport')}
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/bug-reports-features"
                            state={{ from: location }}
                            aria-label={t('global.footer.txtBugReportsAndFeatures')}
                            title={t('global.footer.txtBugReportsAndFeatures')}
                            className="rounded-full border-white/20 text-white/80 transition hover:text-slate-300"
                        >
                            <BugIcon className="w-4 h-4" />
                        </Link>
                    </li>
                </ul>
            </div>
        </footer>
    );
}
